import { Input } from './input';

/**
 * Handler for multiple value input fields (like checkboxes)
 */

export class MultiValueInput extends Input {

	/**
	 * @param {HTMLElement} elem - the input type text field
	 * @param {FormHandler} form - the form, the current element belongs to
	 * @constructor
	 */
	constructor(elem, form) {
		super(elem, form);
		this.addEventHandlers();
	}

	validate() {
		this.form.validation.validateInputGroup(this.elem.name, this.elem.type, this.inputGroup).then((data) => {
			this.handleValidationResponse(data);
		});
	}

	get inputGroup() {
		const type = this.elem.type;
		if(type === 'radio' || type === 'checkbox') {
			return this.elem.form.querySelectorAll(`input[name="${this.elem.name}"]:checked`);
		} else {
			return this.elem.form.querySelectorAll(`input[name="${this.elem.name}"]`);
		}
	}

	static getSelector() {
		return 'input[type="checkbox"],' +
			'input[type="radio"]';
	}
}

